import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { useContent } from "@/context/ContentContext";

export const OfferPopup = () => {
  const { content } = useContent();
  const OFFER = content.offer || {};
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (OFFER.enabled === false) return;
    if (!sessionStorage.getItem("rtpl-offer-seen") && OFFER.title) {
      const t = setTimeout(() => setOpen(true), 1200);
      return () => clearTimeout(t);
    }
  }, [OFFER.enabled, OFFER.title]);

  const dismiss = () => {
    sessionStorage.setItem("rtpl-offer-seen", "1");
    setOpen(false);
  };

  const purchase = () => {
    dismiss();
    navigate(`/support?category=${encodeURIComponent(OFFER.ctaCategory)}`);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && dismiss()}>
      <DialogContent
        className="max-w-lg overflow-hidden rounded-xl border-2 border-border p-0"
        data-testid="offer-popup"
      >
        <div className="relative aspect-[16/10] w-full overflow-hidden bg-gradient-to-br from-primary/10 to-secondary/20">
          <img
            src={OFFER.image}
            alt={OFFER.title}
            className="h-full w-full object-contain p-6"
          />
          <span className="absolute left-0 top-0 bg-primary px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-white">
            {OFFER.badge}
          </span>
        </div>
        <div className="p-6 md:p-8">
          <DialogTitle className="font-heading text-2xl font-bold tracking-tight text-foreground">
            {OFFER.title}
          </DialogTitle>
          <DialogDescription className="mt-3 text-sm leading-relaxed text-muted-foreground">
            {OFFER.description}
          </DialogDescription>
          <button
            onClick={purchase}
            data-testid="offer-purchase-btn"
            className="mt-6 flex w-full items-center justify-center gap-2 rounded-xl bg-primary px-6 py-3.5 font-heading text-sm font-bold uppercase tracking-wide text-white shadow-md transition-colors hover:bg-primary/90 hover:shadow-lg"
          >
            {OFFER.ctaLabel} <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
